import React from 'react';
import StatusChip from '../StatusChip';

const ProspectStatusChip = ({ status }) => <StatusChip status={status} />;

export default ProspectStatusChip;
